<template>
  <div class="detail">
    <div class="tabs">
      <div
        class="item"
        :class="data.tabsClassFlag('levelOne')"
        @click="data.tabClick('levelOne')"
      >
        <span>团长收入</span>
      </div>
      <div
        class="item"
        :class="data.tabsClassFlag('levelTwo')"
        @click="data.tabClick('levelTwo')"
      >
        <span>提现记录</span>
      </div>
    </div>
    <van-pull-refresh v-model="data.refreshLoading" @refresh="data.onRefresh">
      <van-list
        v-model:loading="data.loading"
        :finished="data.finished"
        finished-text="暂无更多数据"
        @load="data.onLoad"
      >
        <div class="levelOneCardList" v-if="data.quitMemberItem === 'levelOne'">
          <div class="item" v-for="(item, index) in data.getList" :key="index">
            <div class="header">
              <div class="left">
                <div class="userIphone">{{ item.phone }}</div>
                <div class="level">
                  {{ item.level === 1 ? "一级团员" : "二级团员" }}
                </div>
              </div>
              <div class="right">
                收入
                <div class="price">
                  <span class="tip">¥</span>{{ item.amount }}
                </div>
              </div>
            </div>
            <div class="time">结算时间{{ item.ctime }}</div>
          </div>
        </div>
        <div class="levelTwoCardList" v-else>
          <div class="item" v-for="(item, index) in data.getList" :key="index">
            <div class="status" :style="data.getStatus(item.status).background">
              {{ data.getStatus(item.status).text }}
            </div>
            <div class="withdrawalAmount">提现金额:<span>-￥{{ item.amount }}</span>  <div v-if="item.pay_img"  @click="data.proof(item.pay_img)">打款凭证</div></div>
            <div class="userName">姓名: {{ item.name }}</div>
            <div class="account">支付宝账号: {{ item.account }}</div>
            <div class="ctime">申请时间: {{ item.ctime }}</div>
            <div class="time" v-if="item.dispose_time">{{ item.status === 3?'驳回时间':'打款时间'  }}: {{ item.dispose_time }}</div>
            <div v-if="item.reason" class="reason">驳回原因: {{ item.reason }}</div>
          </div>
        </div>
      </van-list>
    </van-pull-refresh>
  </div>
</template>

<script setup>
import {
  ref,
  reactive,
  toRefs,
  onBeforeMount,
  onMounted,
  watchEffect,
  computed,
  defineComponent,
  defineExpose,
} from "vue";
import { useRoute, useRouter } from "vue-router";
import { teamIncome, withdrawList } from "@/api/invite";
import { showToast, showImagePreview } from 'vant';
defineComponent({
  name: "",
});
/**
 * 路由对象
 */
const route = useRoute();
/**
 * 路由实例
 */
const router = useRouter();
//console.log('1-开始创建组件-setup')
/**
 * 数据部分
 */
const data = reactive({});
data.refreshLoading = false;
data.finished = false;
data.loading = false;

data.params = {
  page: 1,
  limit: 10,
};

data.getList = [];

data.quitMemberItem = "levelOne";

data.tabsClassFlag = (e) => {
  if (data.quitMemberItem === e) {
    return "quitItem";
  }
};

data.getTeamIncome = () => {
  data.loading = true;
  teamIncome(data.params)
    .then((res) => {
      data.getList.push(...res.data.data);
      if (res.data.total === data.getList.length) {
        data.finished = true;
      } else {
        data.params.page++;
        data.finished = false;
      }
    })
    .finally(() => {
      data.loading = false;
      data.refreshLoading = false;
    });
};

data.getWithdRawList = () => {
  data.loading = true;
  withdrawList(data.params)
    .then((res) => {
      data.getList.push(...res.data.data);
      if (res.data.total === data.getList.length) {
        data.finished = true;
      } else {
        data.params.page++;
        data.finished = false;
      }
    })
    .finally(() => {
      data.loading = false;
      data.refreshLoading = false;
    });
};

data.tabClick = (e) => {
  data.params.page = 1;
  data.finished = false;
  data.quitMemberItem = e;
  data.getList = [];
  if (e === "levelOne") {
    data.getTeamIncome();
  } else {
    data.getWithdRawList();
  }
};

data.onLoad = () => {
  if (data.quitMemberItem === "levelOne") {
    data.getTeamIncome();
  } else {
    data.getWithdRawList();
  }
};

data.onRefresh = () => {
  data.params.page = 1;
  data.getList = [];
  if (data.quitMemberItem === "levelOne") {
    data.getTeamIncome();
  } else {
    data.getWithdRawList();
  }
};

data.getStatus = (e) => {
  let params = {
    text: "",
    background: "",
  };
  switch (e) {
    case 1:
      params.text = "待审核";
      params.background = "background: #8368FC;";
      break;
    case 2:
      params.text = "已打款";
      params.background = "background: #8368FC;";
      break;
    case 3:
      params.text = "提现失败";
      params.background = "background: #FF5050;";
      break;
  }
  return params;
};

data.proof = (e) => {
  showImagePreview({
  images: [
    e,
  ],
  closeable: true,
});
}

onBeforeMount(() => {
  //console.log('2.组件挂载页面之前执行----onBeforeMount')
});
onMounted(() => {
  //console.log('3.-组件挂载到页面之后执行-------onMounted')
});
watchEffect(() => {});
// 使用toRefs解构
// let { } = { ...toRefs(data) }
defineExpose({
  ...toRefs(data),
});
</script>
<style lang="scss" scoped>
.tabs {
  display: flex;
  border-bottom: 1px solid #ffffff20;
  .item {
    text-align: center;
    flex: 1;
    font-weight: 400;
    color: #f7f5ff80;
    font-size: 28px;
    padding: 19px 0;
  }
  .quitItem {
    color: #ffffff;
    font-size: 30px;
    font-weight: 500;
    span {
      position: relative;
    }
  }
  .quitItem {
    span::after {
      content: "";
      position: absolute;
      bottom: -24px;
      left: 36px;
      height: 4px;
      background: #8368fc;
      border-radius: 3px;
      width: 48px;
      // margin: 0 61px;
    }
  }
}
.levelOneCardList {
  .item {
    margin: 24px;
    background: #323647;
    border-radius: 16px;
    .header {
      padding: 24px;
      color: #ffffff;
      display: flex;
      border-bottom: 1px solid #f7f5ff30;
      justify-content: space-between;
      .left {
        display: flex;
        align-items: center;
        .userIphone {
          font-size: 30px;
          font-weight: 500;
        }
        .level {
          background: #8368fc;
          border-radius: 8px;
          font-weight: 400;
          color: #f7f5ff;
          font-size: 20px;
          padding: 2px 4px;
          margin-left: 12px;
        }
      }
      .right {
        display: flex;
        align-items: center;
        .price {
          color: #e6a534;
          font-family: DINAlternate-Bold;
          font-weight: 700;
          font-size: 32px;
          .tip {
            font-size: 28px;
            margin: 0 5px;
            font-family: PingFangSC-Regular;
            font-weight: NaN;
          }
        }
      }
    }
    .time {
      padding: 24px;
      padding-top: 16px;
      font-weight: 400;
      color: #f7f5ff60;
      font-size: 24px;
    }
  }
}
.levelTwoCardList {
  color: #ffffff;
  .item {
    margin: 24px;
    background: #323647;
    border-radius: 16px;
    position: relative;
    padding: 32px 0;
    .status {
      position: absolute;
      top: 0;
      right: 0;
      width: 148px;
      height: 48px;
      text-align: center;
      line-height: 48px;
      border-radius: 0px 16px 0px 16px;
    }
    .withdrawalAmount {
      display: flex;
      align-items:center;
      padding: 0 32px;
      font-weight: 400;
      color: #ffffff;
      font-size: 28px;
      span {
        font-family: DINAlternate-Bold, DINAlternate;
        font-weight: bold;
        color: #f2a100;
        font-size: 32px;
        margin-left: 4px;
        margin-right: 20px;
      }
      div {
        text-decoration: underline;
        color: #8368FC;
      }
    }
    .userName {
      padding: 0 32px;
      margin-top: 28px;
      font-weight: 400;
      color: #ffffff;
      font-size: 30px;
    }
    .account {
      padding: 0 32px;
      margin-top: 28px;
      padding-bottom: 28px;
      border-bottom: 1px solid #f7f5ff30;
    }
    .ctime {
      padding: 0 32px;
      padding-top: 18px;
      font-size: 28px;
      font-weight: 400;
      color: #f7f5ff80;
    }
    .time {
      padding: 0 32px;
      padding-top: 16px;
      font-size: 28px;
      font-weight: 400;
      color: #f7f5ff80;
    }
    .reason {
      padding: 0 32px;
      padding-top: 16px;
      font-weight: 400;
color: #FF5050;
font-size: 28px;
    }
  }
}
.van-list {
  height: calc(100vh - 210px);
  overflow: hidden;
  overflow-y: auto;
}

.van-list::-webkit-scrollbar {
  width: 0 !important;
}
</style>
<style>
:root {
  --van-image-preview-close-icon-size:50px
}
</style>
